import React from 'react';
import { css } from '@emotion/react';
import { Avatar } from '$/images/Icons';
import { MediaRefFragment } from '$/GraphQL/schema/types';
import { useImageSrcFromRef } from '$/hooks/useImageSrcFromRef';

interface PictureProps {
  className?: string;
  alt?: string;
  pictureRef?: MediaRefFragment | null;
  size?: number;
  onClick?: () => void;
}
const CirclePicture: React.FC<PictureProps> = ({
  onClick,
  className,
  alt,
  pictureRef,
  size = 42,
}) => {
  const dim = React.useMemo(() => ({ width: size, height: size }), [size]);

  let profileUrl = useImageSrcFromRef(pictureRef, {
    w: dim.width,
    h: dim.height,
    ar: 1,
    faceindex: 1,
    facepad: 5,
    mask: 'ellipse',
    fit: 'facearea',
  });

  if (!pictureRef?.crop) {
    // If there's no crop then we need ot use server side URL which does auto-face detection
    profileUrl = pictureRef?.imageUrl;
  }

  return (
    <div
      onClick={(): void => {
        onClick && onClick();
      }}
      className={`bg-blue-1 rounded-full overflow-hidden flex items-center justify-center bg-cover ${className}`}
      css={css`
        width: ${size}px;
        height: ${size}px;
        img {
          max-width: 100%;
        }
      `}
    >
      {pictureRef ? (
        <img src={`${profileUrl}`} alt={alt || pictureRef.alt || 'Profile image'} />
      ) : (
        <Avatar className='h-1_5e' />
      )}
    </div>
  );
};
export default CirclePicture;
